<template>
  <div>
    <title>商品列表</title>
    <section class="goodsBox">
      <!-- S 统计列表信息组件 -->
      <CardStatisticsInfo :cateType="0"></CardStatisticsInfo>
      <!-- E 统计列表信息组件 -->
    </section>
  </div>
</template>
<script>
export default {
  name:'CardStatisticsList',
  data () {
    return {
      cateType:0, //当前选中菜单
    }
  },
  filters: {

  },
  components: {
    CardStatisticsTab: resolve => require(["@/components/StatisticsFolder/CardStatisticsTab.vue"],resolve), //头部tab组件
    CardStatisticsInfo: resolve => require(["@/components/StatisticsFolder/CardStatisticsInfo.vue"],resolve), // 统计列表信息组件
  },
  // ============================================== 监听 ==============================================
 watch: {
    
  },
  // ============================================== 方法 ==============================================
  methods: {
  },
  created() {
  },
  mounted () {

  },
  computed: {},
  destroyed(){
  }
}
</script>
<style scoped>
.goodsBox {padding:20px; height:calc(100% - 40px);}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/CardStatistics/CardStatisticsList.vue